import { Button, Container, Paper, Text } from "@mantine/core";
import { useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";

import { useCreateEvent } from "../../api/event";
import { AuthContext } from "../../services/context";
import { reduceWhiteSpaces } from "../../services/helper";
import { getCurrentWorkspace } from "../../services/userConfig";
import resolver from "@congrs/resolver";
import { web_createEventSchema } from "@congrs/schemas";
import FeatureFlagsSelector from "./FeatureFlagsSelector";

function CreateEvent() {
  const { user } = useContext(AuthContext);

  const isSysAdmin = user?.role === "sysAdmin";
  const workspaceId = getCurrentWorkspace(user)?.id;

  const { control, handleSubmit } = useForm({
    defaultValues: {
      nameI18n: {
        en: "",
        sr: "",
      },
      autoCloseDays: null,
      enabledFeatures: [],
      attendeeLimit: null,
    },
    resolver: resolver(web_createEventSchema),
  });

  const { mutate, isPending, isSuccess } = useCreateEvent();

  const onSubmit = (data) => {
    data.nameI18n = {
      en: reduceWhiteSpaces(data.nameI18n.en),
      sr: reduceWhiteSpaces(data.nameI18n.sr ?? ""),
    };

    mutate({ ...data, wsId: workspaceId });
  };

  return (
    <Container size={500}>
      <Paper withBorder shadow="md" p={16} mt={16} radius="md">
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            label="Name"
            placeholder="Name"
            type="text"
            name="nameI18n.en"
            control={control}
            withAsterisk
            mt="md"
            disabled={!isSysAdmin}
          />

          {!isSysAdmin && (
            <Text size="md" c="red" mt="md">
              Only system admins can create new events!
            </Text>
          )}

          <Controller
            name="enabledFeatures"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FeatureFlagsSelector
                value={value}
                onChange={onChange}
                control={control}
                disabled={!isSysAdmin}
              />
            )}
          />

          <Button
            type="submit"
            mt="md"
            loading={isPending}
            disabled={!isSysAdmin || isSuccess}
          >
            Create event
          </Button>
        </form>
      </Paper>
    </Container>
  );
}

export default CreateEvent;
